import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import {
  priceSettingsService,
  type CreateProductPayload,
  type ProductSettings,
  type UpdateProductSettingsPayload,
} from '@/services/priceSettings.service';
import { QUERY_KEYS } from '@/utils/constants';

export const useProductSettings = () =>
  useQuery({
    queryKey: QUERY_KEYS.PRICE_SETTINGS.ALL,
    queryFn: priceSettingsService.getAll,
  });

/** @deprecated Use useProductSettings */
export const usePriceSettings = useProductSettings;

export const useUpdateProductSettings = () => {
  const queryClient = useQueryClient();
  return useMutation<ProductSettings, Error, UpdateProductSettingsPayload>({
    mutationFn: priceSettingsService.update,
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: QUERY_KEYS.PRICE_SETTINGS.ALL });
      void queryClient.invalidateQueries({ queryKey: QUERY_KEYS.PRODUCTS.ALL });
      void queryClient.invalidateQueries({ queryKey: QUERY_KEYS.PRICING.CONFIG });
      void queryClient.invalidateQueries({ queryKey: QUERY_KEYS.PRICING.SLABS });
    },
  });
};

/** @deprecated Use useUpdateProductSettings */
export const useUpdatePriceSettings = useUpdateProductSettings;

export const useCreateProduct = () => {
  const queryClient = useQueryClient();
  return useMutation<ProductSettings, Error, CreateProductPayload>({
    mutationFn: priceSettingsService.createProduct,
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: QUERY_KEYS.PRICE_SETTINGS.ALL });
      void queryClient.invalidateQueries({ queryKey: QUERY_KEYS.PRODUCTS.ALL });
      void queryClient.invalidateQueries({ queryKey: QUERY_KEYS.PRICING.SLABS });
    },
  });
};

export const useDeleteProduct = () => {
  const queryClient = useQueryClient();
  return useMutation<ProductSettings, Error, string>({
    mutationFn: priceSettingsService.deleteProduct,
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: QUERY_KEYS.PRICE_SETTINGS.ALL });
      void queryClient.invalidateQueries({ queryKey: QUERY_KEYS.PRODUCTS.ALL });
      void queryClient.invalidateQueries({ queryKey: QUERY_KEYS.PRICING.SLABS });
    },
  });
};
